/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {CdkScrollable} from '@angular/cdk/scrolling';
import {MatButton} from '@angular/material/button';
import {XmlExportComponent} from '../../shared/xml-export/xml-export.component';
import {MatTooltip} from '@angular/material/tooltip';
@Component({
    selector: 'elohn-save-data-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './save-data-dialog.component.html',
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        XmlExportComponent,
        MatTooltip,
    ]
})
export class SaveDataDialogComponent {

    private readonly dialogRef = inject<MatDialogRef<SaveDataDialogComponent>>(MatDialogRef);

    public static open(
        dialog: MatDialog
    ): MatDialogRef<SaveDataDialogComponent, boolean> {
        return dialog.open(SaveDataDialogComponent);
    }

    public onExported(): void {
        this.dialogRef.close(true);
    }
}
